

import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";


const RequireAdminAuth = ({ children }) => {
  const token = sessionStorage.getItem("accessToken");

  if (!token) return <Navigate to="/admin-html-secure-metro/login" replace />;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
      // Token expired
      sessionStorage.clear();
      return <Navigate to="/admin-html-secure-metro/login" replace />;
    }
  } catch (error) {
    // Token invalid
    sessionStorage.clear();
    return <Navigate to="/admin-html-secure-metro/login" replace />;
  }

  return children;
};

export default RequireAdminAuth;
